(function () {
  var INTERVAL         = 8000;
  var INTENT_THRESHOLD = 8;

  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    if (carousel.dataset.cdiInit) return;
    carousel.dataset.cdiInit = '1';
    var slides  = Array.from(carousel.querySelectorAll('[data-slide]'));
    var dots    = Array.from(carousel.querySelectorAll('[data-dot]'));
    var total   = slides.length;
    if (total < 2) return;

    var current = 0;
    var pending = null;

    function restartFill(dot) {
      var fill = dot && dot.querySelector('.cdi-home-hero__dot-fill');
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.style.transition = 'width ' + INTERVAL + 'ms linear';
          fill.style.width = '100%';
        });
      });
    }

    function clearFill(dot) {
      var fill = dot && dot.querySelector('.cdi-home-hero__dot-fill');
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = '0%';
    }

    function scheduleNext() {
      clearTimeout(pending);
      pending = setTimeout(function () {
        if (slides[current].contains(document.activeElement)) {
          restartFill(dots[current]);
          scheduleNext();
          return;
        }
        goTo(current + 1);
      }, INTERVAL);
    }

    function goTo(idx) {
      var next = (idx + total) % total;
      clearFill(dots[current]);
      dots[current].classList.remove('is-active');
      dots[current].removeAttribute('aria-current');
      if (next !== current) {
        slides[current].classList.remove('is-active', 'is-entering');
        slides[current].setAttribute('inert', '');
      }
      slides[current].style.opacity = '';
      current = next;
      slides[current].classList.add('is-active');
      slides[current].classList.remove('is-entering');
      slides[current].removeAttribute('inert');
      slides[current].style.opacity = '';
      dots[current].classList.add('is-active');
      dots[current].setAttribute('aria-current', 'true');
      restartFill(dots[current]);
      scheduleNext();
    }

    restartFill(dots[0]);
    scheduleNext();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(pending);
      } else {
        restartFill(dots[current]);
        scheduleNext();
      }
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-dot'), 10));
      });
    });

    carousel.querySelectorAll('[data-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(btn.getAttribute('data-nav') === 'prev' ? current - 1 : current + 1);
      });
    });

    var dragStartX   = null;
    var dragStartY   = null;
    var dragIntent   = null;
    var dragCaptured = false;
    var dragNextIdx  = null;
    var carouselW    = 0;

    function dragReset() {
      dragStartX = null; dragStartY = null;
      dragIntent = null; dragCaptured = false; dragNextIdx = null;
    }

    function dragSetup(startX, startY) {
      dragStartX   = startX;
      dragStartY   = startY;
      dragIntent   = null;
      dragCaptured = false;
      dragNextIdx  = null;
      carouselW    = carousel.offsetWidth;
      clearTimeout(pending);
    }

    function dragMove(x, y, dx) {
      var adx = Math.abs(dx);
      var ady = Math.abs(y - dragStartY);

      if (dragIntent === null) {
        if (ady > adx + INTENT_THRESHOLD) { dragIntent = 'vertical'; return false; }
        if (adx > ady + INTENT_THRESHOLD) { dragIntent = 'horizontal'; }
        else return false;
      }
      if (dragIntent === 'vertical') return false;

      if (!dragCaptured) {
        dragCaptured = true;
        dragNextIdx  = dx < 0
          ? (current + 1) % total
          : (current - 1 + total) % total;
        carousel.classList.add('cdi-home-hero--dragging');
        slides[dragNextIdx].classList.add('is-entering');
        slides[dragNextIdx].removeAttribute('inert');
        slides[dragNextIdx].style.opacity = '0';
      }

      var progress = Math.min(1, adx / (carouselW * 0.5));
      slides[current].style.opacity     = String(1 - progress);
      slides[dragNextIdx].style.opacity = String(progress);
      return true;
    }

    function dragCommit() {
      carousel.classList.remove('cdi-home-hero--dragging');
      var idx = dragNextIdx;
      dragReset();
      goTo(idx);
    }

    function dragRevert() {
      carousel.classList.remove('cdi-home-hero--dragging');
      slides[current].style.opacity = '';
      if (dragNextIdx !== null) {
        slides[dragNextIdx].style.opacity = '';
        slides[dragNextIdx].classList.remove('is-entering');
        slides[dragNextIdx].setAttribute('inert', '');
      }
      dragReset();
      scheduleNext();
    }

    function isControl(target) {
      return !!target.closest('a, button');
    }

    carousel.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (!e.isPrimary) return;
      if (isControl(e.target)) return;
      dragSetup(e.clientX, e.clientY);
    });

    carousel.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      if (dragStartX === null || !e.isPrimary) return;
      var dx = e.clientX - dragStartX;
      var isHoriz = dragMove(e.clientX, e.clientY, dx);
      if (isHoriz && !e.buttons) return;
      if (isHoriz && dragCaptured && !carousel.hasPointerCapture(e.pointerId)) {
        carousel.setPointerCapture(e.pointerId);
      }
    });

    carousel.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'touch') return;
      if (dragStartX === null || !e.isPrimary) return;
      if (!dragCaptured) { dragReset(); scheduleNext(); return; }
      dragCommit();
    });

    carousel.addEventListener('pointercancel', function (e) {
      if (e.pointerType === 'touch') return;
      if (dragStartX === null) return;
      if (!dragCaptured) { dragReset(); scheduleNext(); return; }
      dragRevert();
    });

    carousel.addEventListener('touchstart', function (e) {
      if (isControl(e.target)) return;
      var t = e.changedTouches[0];
      dragSetup(t.clientX, t.clientY);
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      if (dragStartX === null) return;
      var t  = e.changedTouches[0];
      var dx = t.clientX - dragStartX;
      var isHoriz = dragMove(t.clientX, t.clientY, dx);
      if (isHoriz && e.cancelable) e.preventDefault();
    }, { passive: false });

    carousel.addEventListener('touchend', function () {
      if (dragStartX === null) return;
      if (!dragCaptured) { dragReset(); scheduleNext(); return; }
      dragCommit();
    });

    carousel.addEventListener('touchcancel', function () {
      if (dragStartX === null) return;
      if (!dragCaptured) { dragReset(); scheduleNext(); return; }
      dragRevert();
    });
  });
})();
